import { useEffect } from "react";

const setMeta = (name: string, content: string) => {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
  }, [title, description]);
}